import { ISP_Fan } from './types'
import { themedUseStyletron } from '../../../theme/customTheme'
import { OperatorPanelWrapperWithChildren } from '../../components/Layout'
import { SmallPanel } from './SmallPanel'

export function OperatorPanel(props: ISP_Fan) {
    const [, theme] = themedUseStyletron();


    return (
        <OperatorPanelWrapperWithChildren
            resourceGroupId={props.resourceGroupId}
            objectId={props.id}
            statusContent={
                <SmallPanel  {...props}></SmallPanel>
            }>
        </OperatorPanelWrapperWithChildren>

    );
}

